import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ServiceSection from './pages/ServiceSection';
import PortfolioSection from './pages/PortfolioSection';
import BlogSection from './pages/BlogSection';
import TestimonialSection from './pages/TestimonialSection';
import JobSection from './pages/JobSection';
import ContactSection from './pages/ContactSection';
import AboutSection from './pages/AboutSection';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="relative dark:bg-gray-900 transition-colors duration-200">
    <Navbar />
    <main className="pt-16">
      {children}
    </main>
    <Footer />
    <ChatWidget />
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutSection />} />
            <Route path="/services" element={<ServiceSection />} />
            <Route path="/portfolio" element={<PortfolioSection />} />
            <Route path="/blog" element={<BlogSection />} />
            <Route path="/testimonials" element={<TestimonialSection />} />
            <Route path="/jobs" element={<JobSection />} />
            <Route path="/contact" element={<ContactSection />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
